import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Icon, Input, Col, Row, Select, Modal } from 'antd';
import ArticulosRequest from '../../services/Articulos';
import { openNotification } from '../../util/notificaciones';
import CategoriasRequest from '../../services/Categorias';
import FormEstatusProductos from './FormEstatusProductos';
import CatalogosRequest from '../../services/Catalogos';
import PedidosRequest from '../../services/Pedidos';
import ResponsiveCard from '../Common/ResponsiveCard';
const { Option } = Select;


/**
 * Clase para ver el proceso de mostrar artículos
 */
export default class TablaArticulos extends Component {
    state = {
        filterText: "",
        arrArticulos: [],
        arrCategorias: [],
        arrSegmentos: [],
        selectedRowKeys: [],
        selectedRows: [],
        categoriaSelected: null,
        segmentoSelected: null,
        segmentoUsuario: null,
        filtros: {
            filtro: undefined,
            categoria: this.props.location.state.categoria_id,
            id_drives: undefined,
            page: undefined,
            segmento_id: undefined,
        },
        cargando: false,
        paginacion: {},
        modalEstatus: false,
        arrRegiones: [],
        arrSucursales: [],
        arrPlazas: [],
        arrDrives: [],
        regionSelected: null,
        sucursalSelected: null,
        plazaSelected: null,
        drivesSelected: [],
        disableDeleteFilters: true,
        disableApplyFilters: true,
        productoSelected: null,
        cargandoFallo: false,
        arrArticulosFallo: [],
        mostrarModalFallo: false,
        paginaSiguiente: 1,
    }

    /**
     * Comportamiento del componente al mostrar los productos
     */
    componentDidMount = () => {
        let state = { ...this.state }
        state.cargando = true;
        this.setState(state, () => {
            CategoriasRequest.ListarCategorias().then(response => {
                state.arrCategorias = response.data
                if (['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role"))) {
                    return CatalogosRequest.ListarSegmentosConfigurados();
                } else {
                    return PedidosRequest.ListarSitiosSupervisor();
                }
            }).then(response => {
                if (['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role"))) {
                    state.arrSegmentos = response.data;
                } else {
                    if (response.data.segmento) {
                        state.segmentoUsuario = response.data.segmento;
                    } else {
                        openNotification(
                            "El usuario no tiene asignado ningún segmento.",
                            "Error al cargar segmentos del usuario",
                            false,
                        );
                        throw new Error("Error al cargar segmentos del usuario");
                    }
                }
                return CatalogosRequest.ListarRegiones();
            }).then(response => {
                state.arrRegiones = response.data
                state.cargando = false
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification("Ha ocurrido un error al listar los artículos.", "Error al listar artículos", false)
            })
        })
    }

    /**
     * Funcion interna de ant para el manejo de los checkbox
     * 
     * @param: selectedRowKeys (la necesita ant): id de los renglones, selectedRows: toda la informacion del objeto seleccionado
     * @return: nada
     */
    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys, selectedRows });
    };

    /**
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }

        state.paginaSiguiente = paginaSiguiente
        state.filtros.page = paginaSiguiente
        state.cargando = true
        this.setState(state, () => {
            ArticulosRequest.ListarArticulos(state.filtros, paginaSiguiente).then(response => {
                state.paginacion.current = paginaSiguiente
                state.arrArticulos = response.data.results
                state.cargando = false
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification("Ha ocurrido un error al listar los artículos.", "Error al listar artículos", false)
            })
        })
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        let buscar = false;

        if (value.trim() !== state.filterText.trim()) buscar = true
        state.filterText = value;
        state.filtros.filtro = value.trim() === "" ? undefined : value.trim()
        state.paginaSiguiente = 1
        this.setState(state);
        if (buscar) {
            clearTimeout(state.timer)
            state.timer = setTimeout(() => {
                this.filtrarBack();
            }, 1000);
        }
    }

    /**
     * Función que se encarga de hacer las peticion en el back para filtrar
     * por los siguientes valores : 
     * {empresa: int, categoria:int, 
     *  subcategoria:int estatus:bool, 
     *  categorizado:bool, 
     *  nombre/codigo:string/int
     *  }
     */
    filtrarBack = (info) => {
        let state = { ...this.state };
        var values = info
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }
        state.modalEstatus = false;
        state.filtros.page = state.paginaSiguiente;
        state.cargando = true;
        this.setState(state, () => {
            if (state.drivesSelected.length === 1) {
                ArticulosRequest.ListarArticulos(state.filtros).then(response => {
                    if (values !== undefined) {
                        if (values.articulos_no_disponibles.length) {
                            state.arrArticulosFallo = values.articulos_no_disponibles;
                            state.mostrarModalFallo = true;
                        }
                    }
                    state.arrArticulos = response.data.results
                    state.cargando = false
                    state.paginacion = {
                        current: state.paginaSiguiente,
                        total: response.data.count,
                        onChange: this.handlePaginaChange,
                        pageSize: 10,
                        showTitle: false
                    }

                    this.setState(state)
                }).catch(err => {
                    this.setState({ cargando: false })
                    openNotification("Ha ocurrido un error al listar los artículos.", "Error al listar artículos", false)
                })
            } else {
                ArticulosRequest.ListarArticulos(state.filtros).then(response => {
                    if (values !== undefined) {
                        if (values.articulos_no_disponibles.length) {
                            state.arrArticulosFallo = values.articulos_no_disponibles;
                            state.mostrarModalFallo = true;
                        }
                    }
                    state.arrArticulos = response.data.results
                    state.cargando = false
                    state.paginacion = {
                        current: state.paginaSiguiente,
                        total: response.data.count,
                        onChange: this.handlePaginaChange,
                        pageSize: 10,
                        showTitle: false
                    }
                    this.setState(state)
                }).catch(err => {
                    this.setState({ cargando: false })
                    openNotification("Ha ocurrido un error al listar los artículos.", "Error al listar artículos", false)
                })
            }

        })
    }

    /**
     * Función para limpiar todos los filtros que han
     * sido manipulados por el usuario.
     * @param: nada
     * @return: nada
     */
    cleanFilters = () => {
        let state = { ...this.state }
        state.disableApplyFilters = true;
        state.disableDeleteFilters = true;
        state.filtros.categoria = undefined;
        state.filtros.filtro = undefined;
        state.filtros.id_drives = undefined
        state.filtros.segmento_id = undefined
        state.filtros.page = 1;
        state.categoriaSelected = null;
        state.filterText = "";
        state.selectedRowKeys = [];
        state.selectedRows = [];
        state.regionSelected = null;
        state.arrSucursales = [];
        state.sucursalSelected = null;
        state.arrPlazas = [];
        state.plazaSelected = null;
        state.arrDrives = [];
        state.drivesSelected = [];
        state.arrArticulos = [];
        state.paginacion = {
            current: 0,
            total: 0,
            onChange: this.handlePaginaChange,
            pageSize: 0,
            showTitle: false
        }
        state.segmentoSelected = null;
        
        this.setState(state);
        openNotification("Los filtros se han limpiado correctamente.", "Filtros limpiados correctamente", true);
    }

    /**
     * Función que muestra el modal de estatus
     * @param: nada.
     * @return: nada.
     */
    showModal = () => {
        this.setState({ modalEstatus: true })
    }

    /**
     * Función que esconde el modal de estatus
     * @param: value. valor para esconder el modal
     * @return: nada.
     */
    esconderModal = (value, data) => {
        let state = { ...this.state }
        if (value) {
            state.modalEstatus = false;
            state.selectedRows = [];
            state.selectedRowKeys = [];
            state.productoSelected = null;
            this.setState(state, () => {
                this.filtrarBack(data)
            })
        }
        this.setState({ modalEstatus: false, productoSelected: null })
    }

    /**
     * Función que se cambia la región
     * @param: value. valor del id de la región
     * @return: nada.
     */
    handleChangeRegion = (value) => {
        let state = { ...this.state }
        state.sucursalSelected = null;
        state.plazaSelected = null;
        state.drivesSelected = [];
        state.arrArticulos = [];
        state.selectedRowKeys = [];
        state.selectedRows = [];
        state.filtros.id_drives = [];
        state.filtros.segmento_id = undefined;
        state.filterText = "";
        state.filtros.filtro = "";
        state.paginacion = {
            current: 0,
            total: 0,
            onChange: this.handlePaginaChange,
            pageSize: 0,
            showTitle: false
        }
        state.disableApplyFilters = true
        if (value === undefined) {
            state.regionSelected = null;
            state.disableDeleteFilters = true
        } else {
            state.regionSelected = value
            CatalogosRequest.ListarSucursalesRegion(value).then(response => {
                state.arrSucursales = response.data
                state.disableDeleteFilters = false
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las sucursales de la región.",
                    "Error al cargar sucursales",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la sucursal
     * @param: value. valor del id de la sucursal
     * @return: nada.
     */
    handleChangeSucursal = (value) => {
        let state = { ...this.state }
        state.plazaSelected = null;
        state.drivesSelected = [];
        state.arrArticulos = [];
        state.selectedRowKeys = [];
        state.selectedRows = [];
        state.filtros.id_drives = [];
        state.filtros.segmento_id = undefined;
        state.filterText = "";
        state.filtros.filtro = "";
        state.paginacion = {
            current: 0,
            total: 0,
            onChange: this.handlePaginaChange,
            pageSize: 0,
            showTitle: false
        }
        state.disableApplyFilters = true
        if (value === undefined) {
            state.sucursalSelected = null;
        } else {
            state.sucursalSelected = value
            CatalogosRequest.ListarPlazasSucursal(value).then(response => {
                state.arrPlazas = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las plazas de la sucursal.",
                    "Error al cargar plazas",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
     */
    handleChangePlaza = (value) => {
        let state = { ...this.state }
        state.drivesSelected = [];
        state.arrArticulos = [];
        state.selectedRowKeys = [];
        state.selectedRows = [];
        state.filtros.id_drives = [];
        state.filtros.segmento_id = undefined;
        state.filterText = "";
        state.filtros.filtro = "";
        state.paginacion = {
            current: 0,
            total: 0,
            onChange: this.handlePaginaChange,
            pageSize: 0,
            showTitle: false
        }
        state.disableApplyFilters = true
        if (value === undefined) {
            state.plazaSelected = null;
        } else {
            state.plazaSelected = value;
            const role = localStorage.getItem("role");
            if (role !== 'Administrador' && role !== 'SuperAdmin') {
                CatalogosRequest.ListarSitios(value, state.segmentoUsuario).then(response => {
                    state.arrDrives = response.data
                    this.setState(state)
                }).catch(err => {
                    openNotification(
                        "Ha ocurrido un error al cargar los puntos de venta de la plaza.",
                        "Error al cargar puntos de venta",
                        false
                    )
                })
            }
        }

        this.setState(state)
    }

    /**
     * Función que se cambia el segmento
     * @param: value. valor del id del segmento
     * @return: nada.
     */
    handleChangeSegmento = (value) => {
        let state = { ...this.state }
        state.drivesSelected = [];
        state.arrArticulos = [];
        state.selectedRowKeys = [];
        state.selectedRows = [];
        state.filtros.id_drives = [];
        state.filterText = "";
        state.filtros.filtro = "";
        state.paginacion = {
            current: 0,
            total: 0,
            onChange: this.handlePaginaChange,
            pageSize: 0,
            showTitle: false
        }
        state.disableApplyFilters = true
        if (value === undefined) {
            state.segmentoSelected = null;
            state.filtros.segmento_id = undefined;
        } else {
            state.segmentoSelected = value
            state.filtros.segmento_id = value;
            CatalogosRequest.ListarSitios(state.plazaSelected, value).then(response => {
                state.arrDrives = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar los drives de la plaza.",
                    "Error al cargar drives",
                    false
                )
            })
        }

        this.setState(state)
    }



    /**
     * Función cuando se cambia el combo de drive
     * @param: value. valor del id del drive
     * @return: nada.
     */
    handleChangeDrive = (value) => {
        let state = { ...this.state }
        state.arrArticulos = [];
        state.selectedRowKeys = [];
        state.selectedRows = [];
        state.filterText = "";
        state.filtros.filtro = "";
        state.paginacion = {
            current: 0,
            total: 0,
            onChange: this.handlePaginaChange,
            pageSize: 0,
            showTitle: false
        }
        if (!value.length) {
            state.drivesSelected = [];
            state.filtros.id_drives = [];
            state.disableApplyFilters = true;
        } else {
            state.drivesSelected = value
            state.filtros.id_drives = value
            state.disableApplyFilters = false;
        }

        this.setState(state)
    }

    render() {
        const categoria = this.props.location.state.categoria;
        const modelo = this.props.location.state.modelo;
        const drives = this.state.drivesSelected;
        const role = localStorage.getItem("role");
        const esAdmin = role === "Administrador" || role === "SuperAdmin";

        const columnasArticulos = [
            {
                title: "Código",
                dataIndex: "codigo",
                key: "codigo"
            },
            {
                title: "Nombre",
                dataIndex: "descripcion",
                key: "descripcion"
            },
            {
                title: "UDMP",
                dataIndex: "unidad_venta",
                key: "unidad_venta"
            },
            // {
            //     title: 'Acciones',
            //     dataIndex: 'Acciones',
            //     key: 'Acciones',
            //     render: (value, record) => (
            //         <div >
            //             {drives.length === 1 &&
            //                 <span className={ !esAdmin ? 'display-none' : ''} style={{ marginRight: 5 }}>
            //                     <Tooltip placement="top" title={"Editar estatus de producto"}>
            //                         <Button
            //                             id="boton-editar-estatus-producto-form"
            //                             icon="edit"
            //                             className="btnEditar"
            //                             onClick={() => {
            //                                 this.setState({
            //                                     productoSelected: record,
            //                                     modo: "uno",
            //                                 }, this.showModal())
            //                             }}
            //                         >
            //                         </Button>
            //                     </Tooltip>
            //                 </span>
            //             }

            //         </div>
            //     )
            // }
        ]
        const columnasFallo = [
            {
                title: "Artículo",
                dataIndex: "articulo",
                key: "articulo"
            },
            {
                title: "Drive",
                dataIndex: "drive",
                key: "drive"
            },
            {
                title: "Error",
                dataIndex: "error",
                key: "error"
            },
        ]
        const { selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            hideDefaultSelections: true,
            selections: [
                {
                    key: 'all-data',
                    text: 'Seleccionar todo',
                    onSelect: () => {
                        this.setState({
                            selectedRowKeys: this.state.arrArticulos.map(item => item.id),
                            selectedRows: [...this.state.arrArticulos]
                        });
                    },
                },
                {
                    key: 'un-select-all',
                    text: 'Deseleccionar todo',
                    onSelect: changableRowKeys => {
                        this.setState({ selectedRowKeys: [], selectedRows: [] });
                    },
                },
            ],
        };

        return (
            <ResponsiveCard id="ParentSize"
                title="Módulo productos"
                extra={
                    <div>
                        <Button
                            id="boton-atras-tabla-productos"
                            className="btnCancelar"
                            key="back"
                            style={{ marginRight: "10px" }}
                            onClick={() => {
                                this.props.history.goBack()
                            }}
                        >
                            Atrás
                    </Button>
                        <Button
                            className={!esAdmin ? 'display-none' : ''}
                            type="primary"
                            id="boton-editar-estatus-articulos"
                            disabled={!this.state.selectedRowKeys.length}
                            onClick={() => {
                                this.setState({
                                    modo: "varios",
                                }, this.showModal())
                            }}
                        >
                            Editar Estatus
                        </Button>
                    </div>
                }>

                <div className="panel-block">
                    <div>
                        <Row gutter={12}>
                            <Col span={4}>
                                <div className="center">Modelo:</div>
                                <Input
                                    id="input-modelo-tabla-productos"
                                    type="text"
                                    value={modelo}
                                    className='disableBtn'
                                />
                            </Col>
                            <Col span={5}>
                                <div className="center">Categoría:</div>
                                <Input
                                    id="input-categoria-tabla-productos"
                                    type="text"
                                    value={categoria}
                                    className='disableBtn'
                                />
                            </Col>
                            <Col span={5}>
                                <div className="center">Región:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una región">
                                    <Select
                                        id="select-region-productos-modulo"
                                        showSearch
                                        autoFocus={true}
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        onChange={this.handleChangeRegion}
                                        value={this.state.regionSelected}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrRegiones.length > 0 &&
                                            this.state.arrRegiones.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre_corto}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={5}>
                                <div className="center">Sucursal:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una sucursal">
                                    <Select
                                        id="select-sucursal-productos-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.regionSelected === null ? true : false}
                                        onChange={this.handleChangeSucursal}
                                        value={this.state.sucursalSelected}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrSucursales.length > 0 &&
                                            this.state.arrSucursales.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={5}>
                                <div className="center">Plaza:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una plaza">
                                    <Select
                                        id="select-plaza-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.sucursalSelected === null ? true : false}
                                        onChange={this.handleChangePlaza}
                                        value={this.state.plazaSelected}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrPlazas.length > 0 &&
                                            this.state.arrPlazas.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                        </Row>
                        <br />
                        <Row gutter={12}>
                            <Col className={ esAdmin ? '' : 'display-none'} span={5}>
                                <div className="center">Segmento:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione un segmento">
                                    <Select
                                        id="select-segmento-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.plazaSelected === null ? true : false}
                                        onChange={this.handleChangeSegmento}
                                        value={this.state.segmentoSelected}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrSegmentos.length > 0 &&
                                            this.state.arrSegmentos.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={esAdmin ? 6 : 9}>
                                <div className="center" style={{ textOverflow: "ellipsis", whiteSpace: "nowrap"}}>Punto de venta:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione los puntos de venta">
                                    <Select
                                        id="select-drive-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        mode="multiple"
                                        disabled={ esAdmin
                                            ? this.state.segmentoSelected === null ? true : false
                                            : this.state.plazaSelected === null ? true : false}
                                        onChange={this.handleChangeDrive}
                                        value={this.state.drivesSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrDrives.length > 0 &&
                                            this.state.arrDrives.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={8}>
                                <div className="center">Búsqueda:</div>
                                <Tooltip
                                    placement="top"
                                    title="Buscar por Código / Nombre ">
                                    <Input
                                        maxLength={50}
                                        id="input-buscar-articulos-tabla-productos"
                                        placeholder="Buscar por Código / Nombre"
                                        onChange={(e) => this.filterText(e.currentTarget.value)}
                                        value={this.state.filterText}
                                        disabled={this.state.drivesSelected.length ? false : true}
                                    />
                                </Tooltip>
                            </Col>
                            <Col span={2}>
                                <Tooltip placement="top" title={this.state.drivesSelected.length ? "Realizar búsqueda" : ""}>
                                    <Button
                                        id="boton-filtrar-productos-filtros"
                                        className={this.state.disableApplyFilters ? "disableBtn" : ""}
                                        type={this.state.disableApplyFilters ? "default" : "primary"}
                                        icon="search"
                                        style={{ width: '100%', marginBottom: "30px", marginTop: '1.85em' }}
                                        onClick={() => {
                                            this.setState({ paginaSiguiente: 1 }, this.filtrarBack)
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </Col>
                            <Col span={2}>
                                <Tooltip placement="top" title="Borrar filtros">
                                    <Button
                                        id="boton-borrar-filtros-productos-tabla"
                                        type="default"
                                        icon="delete"
                                        className={this.state.disableDeleteFilters ? 'disableBtn' : ''}
                                        style={{ width: '100%', marginBottom: "30px", marginTop: '1.85em' }}
                                        onClick={this.cleanFilters}
                                    >
                                    </Button>
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>

                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={articulo => articulo.id}
                            columns={columnasArticulos}
                            dataSource={this.state.arrArticulos}
                            rowSelection={rowSelection}
                            pagination={this.state.paginacion}
                            rowClassName={(record) => (this.state.drivesSelected.length === 1 && !record.sitio) || record.estatus_nombre.toLowerCase() === 'off' ? 'no_sitio' : ''}
                        />
                    </Spin>
                </div>
                <FormEstatusProductos
                    esconderModal={this.esconderModal}
                    visible={this.state.modalEstatus}
                    modo={this.state.modo}
                    drives_selected={drives}
                    categoria_selected={this.props.location.state.categoria_id}
                    producto_selected={this.state.productoSelected}
                    arrArticulos={this.state.selectedRows}
                >
                </FormEstatusProductos>
                <Modal
                    title={<p style={{ textAlign: "center", marginBottom: 0 }}>Productos no actualizados</p>}
                    onCancel={() => {
                        this.setState({ mostrarModalFallo: false })
                    }}
                    centered={false}
                    visible={this.state.mostrarModalFallo}
                    maskClosable={false}
                    footer={[
                        <Button
                            className="btnCancelar"
                            key="back"
                            onClick={() => {
                                this.setState({ mostrarModalFallo: false })
                            }}>
                            Regresar
                        </Button>
                    ]}
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargandoFallo}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table
                            size="small"
                            locale={{ emptyText: 'No se han encontrado resultados.' }}
                            rowKey={(articulos, index) => index}
                            columns={columnasFallo}
                            pagination={false}
                            dataSource={this.state.arrArticulosFallo}
                        />
                    </Spin>
                </Modal>
            </ResponsiveCard>
        )
    }
}